<template>
  <div>
    <div style="font-size: 18px;padding-bottom: 20px;text-align: center;">
      {{ this.gpsId ? '编辑GPS设备信息' : '新增GPS设备信息' }}
    </div>
    <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false" :model="form.data"
                  :rules="formRules" ref="gpsForm">
      <a-form-model-item label="箱号" prop="boxNo">
        <a-input v-model="form.data.boxNo" auto-complete="off" placeholder="请输入箱号"></a-input>
      </a-form-model-item>
      <a-form-model-item label="设备编码" prop="gpsCode">
        <a-input v-model="form.data.gpsCode" auto-complete="off" placeholder="请输入设备编码"></a-input>
      </a-form-model-item>
    </a-form-model>
    <!--    <div slot="footer" class="dialog-footer" style="text-align: center;">-->
    <!--      <a-button type="primary" @click="cancel()"-->
    <!--                 class="project-dialog-button">取消-->
    <!--      </a-button>-->
    <!--      <a-button type="primary" @click="save()"-->
    <!--                 class="project-dialog-button">保存-->
    <!--      </a-button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { findGpsCode, updateGpsCode, saveGpsCode } from '../../../api/gpsCode';

async function getGpsCode() {
  if (this.form.data.id) {
    const gpsCode = await findGpsCode(this.form.data.id);
    if (gpsCode.code === 1200) {
      this.$set(this.form.data, 'boxNo', gpsCode.data.bean.boxNo);
      this.$set(this.form.data, 'gpsCode', gpsCode.data.bean.gpsCode);
    }
  } else {
    this.form.data = {};
  }
}

function save() {
  this.$refs.gpsForm.validate(async (valid) => {
    if (valid) {
      if (this.form.data.id) {
        const resultUpdate = await updateGpsCode(this.form.data);
        if (resultUpdate.code === 1200) {
          this.$message.success('更新成功');
          this.getList();
          this.form.data = {};
        } else {
          this.$message.error('更新失败');
        }
      } else {
        const resultAdd = await saveGpsCode(this.form.data);
        if (resultAdd.code === 1200) {
          this.$message.success('添加成功');
          this.getList();
          this.form.data = {};
        } else {
          this.$message.error('添加失败');
        }
      }
    } else {
      this.$message.error('数据格式不正确');
    }
  });
  // this.getList()
}

function cancel() {
  this.$refs.gpsForm.resetFields();
}

export default {
  name: 'GpsNoEdit',
  props: {
    gpsId: String,
    onSaveHandler: Function,
    onCancelHandler: Function,
    getList: Function,
  },
  data() {
    return {
      formLabelWidth: '90px',
      form: {
        data: {
          id: '',
          boxNo: '',
          gpsCode: '',
        },
      },
      formRules: {
        boxNo: [
          {
            required: true,
            message: '请输入箱号',
            trigger: 'blur',
          },
        ],
        gpsCode: [
          {
            required: true,
            message: '请输入GPS设备编码',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  watch: {
    gpsId(val) {
      this.form.data = {};
      this.form.data.id = val;
      this.getGpsCode();
    },
  },
  created() {
    console.log(1234);
    this.form.data.id = this.gpsId;
    this.getGpsCode();
  },
  methods: {
    save,
    cancel,
    getGpsCode,
  },
};
</script>

<style scoped>

</style>
